<template>
  <div>
    <div class="section text-black pt-lg-3 pt-0">
      <div class="container">
        <h2 class="title pt-0 mobile-title my-1">GLI STRUMENTI</h2>
        <h5
          v-if="isGeodidalab"
          class="description mb-0"
          :class="{
            'mobile-subtitle': !isLarge,
          }" 
        >
          I principali strumenti scientifici utilizzati al GeoDidaLab
        </h5>
        <h5
          v-else
          class="description mb-0"
          :class="{
            'mobile-subtitle': !isLarge,
          }"
        >
          I principali strumenti scientifici utilizzati all'Istituto Angelo
          Mosso
        </h5>
      </div>

      <div class="row">
        <div
          v-if="!isGeodidalab"
          :class="isLarge ? 'col-3 mx-4 border-right' : 'col-12 mx-4'"
        >
          <h5 class="mt-3">
            <b>Filtri</b>
          </h5>

          <div class="row" v-if="allAmbitiScientificiLoaded">
            <div class="col-lg-12">
              <!--Interessi-->
              <collapse>
                <collapse-item
                  :title="getAmbitoScientificoCollapseTitle()"
                  name="interests"
                  :isFilter="true"
                >
                  <div class="row mt-3">
                    <div class="col-12">
                      <Button
                        v-if="!selectAllAbitoScientifico"
                        size="small"
                        type="primary"
                        v-on:click="selectAllAbitoScientificoFunctions()"
                        class="m-1"
                        >Seleziona tutto
                      </Button>
                      <Button
                        v-if="selectAllAbitoScientifico"
                        size="small"
                        type="primary"
                        v-on:click="deselectAllAbitoScientificoFunctions()"
                        class="m-1"
                        >Deseleziona tutto
                      </Button>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <div class="mt-2 filterDiv">
                        <div class="form-radio text-left px-1">
                          <n-checkbox
                            v-for="(ambitoScientifico, index) in this.$store
                              .state.ambitiScientificiStrumenti"
                            :key="'ambitoScientifico' + index"
                            v-model="
                              ambitoScientifico.ambitoScientificoSelected
                            "
                            @input="checkAbitoScientifico()"
                          >
                            {{ ambitoScientifico.ambitoScientificoName }}
                          </n-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </collapse-item>
              </collapse>
            </div>
          </div>
        </div>
        <div :class="isGeodidalab ? 'col-12' : isLarge ? 'col-8' : 'col-12'">
          <div class="mt-4" v-if="allLoaded">
            <div class="row text-center d-none d-lg-block">
              <div class="col-12">
                <strumento
                  class="align-top"
                  v-for="(item, index) in this.$store.state.strumenti"
                  :key="index"
                  :item="item"
                  :indexOfStrumento="index + 1"
                  :hasCorrectAmbito="checkIfStrumentoHasCorrectAmbito(item)"
                  :screenSize="'desktop'"
                ></strumento>
              </div>
            </div>

            <div
              class="row mx-2 text-center"
              v-for="(item, index) in this.$store.state.strumenti"
              :key="index"
            >
              <div class="col-12 px-0 d-block d-lg-none">
                <strumento
                  class="align-top"
                  :key="index"
                  :item="item"
                  :indexOfStrumento="index + 1"
                  :hasCorrectAmbito="checkIfStrumentoHasCorrectAmbito(item)"
                  :screenSize="'mobile'"
                ></strumento>
              </div>
            </div>
          </div>
          <div v-else>
            <h4 slot="header" class="title title-up text-center">
              Caricamento in corso
            </h4>
            <div class="loader">
              <svg class="circular">
                <circle
                  class="path"
                  cx="50"
                  cy="50"
                  r="20"
                  fill="none"
                  stroke-width="5"
                  stroke-miterlimit="10"
                ></circle>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ScrollTopArrow :createItinerary="false"></ScrollTopArrow>
  </div>
</template>
<script>
import strumento from "../components/customComponents/strumento";
import $ from "jquery";
import store from "../store";
import { config } from "../utils/config";
import ScrollTopArrow from "../components/customComponents/ScrollTopArrow";
import { Checkbox, Collapse, CollapseItem, Radio, Modal } from "../components";
import { Button } from "element-ui";

const Common = require("@/Common.vue").default;

export default {
  name: "strumenti",
  bodyClass: "strumenti-esperimenti-page",
  components: {
    strumento,
    ScrollTopArrow,
    [Checkbox.name]: Checkbox,
    Collapse,
    CollapseItem,
    Button,
  },
  data() {
    return {
      windowWidth: 0,
      allLoaded: false,
      isGeodidalab: true,
      allAmbitiScientifici: [],
      selectAllAbitoScientifico: false,
      allAmbitiScientificiLoaded: false,
    };
  },

  beforeMount() {
    this.$store.commit("removePOIAndActivities");

    this.isGeodidalab = config.isGeodidalab;

    this.windowWidth = $(window).width();

    $(window).resize(() => {
      this.windowWidth = $(window).width();
    });

    var self = this;

    Common.getElemsByClass(this, config.omekaIDs.omekaIDstrumenti, (res) => {
      store.state.strumenti = res.body;
      self.allLoaded = true;
    });

    Common.getElemsByClass(
      this,
      config.omekaIDs.omekaIDambitoScientifico,
      (res) => {
        store.state.ambitiScientificiOmeka = res.body;
        store.commit("setAllAmbitiScientificiStrumenti");
        store.commit("setAllAmbitiScientificiAttivita");
        self.allAmbitiScientificiLoaded = true;
      }
    );
  },

  methods: {
    selectAllAbitoScientificoFunctions() {
      Array.prototype.forEach.call(
        this.$store.state.ambitiScientificiStrumenti,
        (ambito) => {
          this.$set(ambito, "ambitoScientificoSelected", true);
        }
      );

      this.checkAbitoScientifico();
    },
    deselectAllAbitoScientificoFunctions() {
      Array.prototype.forEach.call(
        this.$store.state.ambitiScientificiStrumenti,
        (ambito) => {
          this.$set(ambito, "ambitoScientificoSelected", false);
        }
      );

      this.checkAbitoScientifico();
    },
    getAmbitoScientificoCollapseTitle() {
      var count = 0;

      Array.prototype.forEach.call(
        this.$store.state.ambitiScientificiStrumenti,
        (ambito) => {
          ambito.ambitoScientificoSelected ? count++ : null;
        }
      );

      var title = "Ambito scientifico"

      if(count === 1) {
        title += " (" + count + " selezionato)"
      } else if (count > 1) {
        title += " (" + count + " selezionati)"
      }

      return title;
    },
    checkAbitoScientifico() {
      var notSelectedPresent = false;

      Array.prototype.forEach.call(
        this.$store.state.ambitiScientificiStrumenti,
        (ambito) => {
          if (!ambito.ambitoScientificoSelected) {
            notSelectedPresent = true;
          }
        }
      );

      if (notSelectedPresent) {
        this.selectAllAbitoScientifico = false;
      } else {
        this.selectAllAbitoScientifico = true;
      }
    },
    checkIfStrumentoHasCorrectAmbito(strumento) {
      if (!this.isGeodidalab) {
        var ambito = strumento["geo:appartiene_a_ambito"][0]["display_title"];

        if (this.selectedAmbiti.length === 0) {
          return true;
        } else {
          if (this.selectedAmbiti.includes(ambito)) {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return true;
      }
    },
  },

  computed: {
    isLarge() {
      return this.windowWidth >= 768;
    },
    selectedAmbiti() {
      var mappedAmbiti = this.$store.state.ambitiScientificiStrumenti
        .filter((ambito) => ambito.ambitoScientificoSelected)
        .map((ambito) => ambito.ambitoScientificoName);

      var allAmbiti = this.$store.state.ambitiScientificiOmeka.map(
        (ambito) => ambito["o:title"]
      );

      if (mappedAmbiti.length === 0) {
        return allAmbiti; //this.allInterests;
      } else {
        return mappedAmbiti;
      }
    },
  },

  watch: {},
};
</script>
<style>
</style>